import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import querystring from 'query-string';
import invariant from 'invariant';

const getContentByUrl = (params) => {
    const { baseUrl, brandId, country, locale, pageUrl, options = {}, clientId } = params;
    invariant(baseUrl, 'baseUrl is a required param of getContentByUrl()');
    invariant(brandId, 'brandId is a required param of getContentByUrl()');
    invariant(country, 'country is a required param of getContentByUrl()');
    invariant(locale, 'locale is a required param of getContentByUrl()');
    invariant(pageUrl, 'pageUrl is a required param of getContentByUrl()');
    invariant(clientId, 'clientId is a required param of getContentByUrl()');

    const headers = new Headers({ 'Content-Type': 'application/json' });
    const localisedBrand = `${brandId}_${country.toLowerCase()}`;
    const queryStrings = querystring.stringify({
        langId: locale,
        url: pageUrl,
        ...options,
    });
    const url = `${baseUrl}blueprint/servlet/contentbyurl/v2/store/${localisedBrand}?${queryStrings}`;

    return labelRequest(authenticatedRequest(new Request(url, { headers }), undefined, clientId), 'getContentByUrl');
};

export default getContentByUrl;
